/* Native eligibility already enforced by Shopify; this only updates explanatory text. */
(() => {
  document.querySelectorAll('[data-halloween-product]').forEach(note => {
    const product = note.closest('[data-product-section]') || document;
    const eligible = new Set(JSON.parse(note.dataset.eligibleIds || '[]').map(String));
    const update = () => {
      const id = product.querySelector('[data-variant-id]')?.value;
      const valid = eligible.has(String(id));
      note.querySelector('[data-halloween-qualified]').hidden = !valid;
      note.querySelector('[data-halloween-excluded]').hidden = valid;
      const action = note.querySelector('[data-halloween-action]');
      if (action) action.hidden = !valid;
      const apply = note.querySelector('[data-halloween-apply]');
      if (apply && id) apply.href = `${window.Shopify?.routes?.root || '/'}discount/WALL25?redirect=${encodeURIComponent(location.pathname + '?variant=' + id)}`;

    };
    product.addEventListener('anivault:variant-change', update);
    update();
  });
})();
